import { ROUTE_CONFIRMATION } from "@/utils/constants";
import { NavigationBar } from "../navigationBar/navigationBar";
import { SimpleStorefrontHours } from "./header";
import ArrowLeftIcon from "../_icons/arrowLeftIcon";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";
import { HeaderMerchantInfoContainer } from "./headerMerchantInfoContainer";
import clsx from "clsx";
import { useNativeBridge } from "@/app/providers/nativeBridgeContext";
import { useNativeActions } from "@/utils/useNativeActions";
import { Menu } from "@/dto/menu";
import { useMerchant } from "@/app/providers/merchantProvider";
import { usePathname } from "next/navigation";
import { DayPart, DayPartMenuCategories } from "@/dto/dayPartMenu";
import { Dispatch, SetStateAction } from "react";
import { CustomerDetails } from "@/dataLayer/getCustomerDetails";
import { GetMerchantPaymentConfigResponse } from "@/dataLayer/getMerchantPaymentConfig";
import { GetMerchantPreferencesResponse } from "@/dataLayer/getMerchantPreferences";
import { Address } from "@/dto/address";
import { BusinessHours } from "@/dto/merchant";
import { NotAcceptingOrdersBanner } from "../notAcceptingOrdersBanner/notAcceptingOrdersBanner";

export interface CmaHeaderProps {
  todaysHours: any;
  businessHours: BusinessHours;
  merchantPaymentConfig: GetMerchantPaymentConfigResponse;
  menu?: Menu;
  customerDetails?: CustomerDetails;
  merchantPreferences?: GetMerchantPreferencesResponse;
  isNotAcceptingOrders: boolean;
  selectedMenu: DayPart | null;
  pickupTimePromise: Promise<any> | undefined;
  isLoading: boolean;
  defaultAddress: Address | null;
  retailCategories: any;
  serviceCategories: any;
  setIsCategoryMenuOpen: Dispatch<SetStateAction<boolean | undefined>>;
  isCategoryMenuOpen?: boolean;
  dayPartMenu?: DayPart[];
  dayPartMenuCategory?: DayPartMenuCategories[];
  setSelectedMenu: Dispatch<SetStateAction<DayPart | null>>;
}

export const CmaHeader = ({
  todaysHours,
  businessHours,
  merchantPaymentConfig,
  menu,
  customerDetails,
  merchantPreferences,
  isNotAcceptingOrders,
  selectedMenu,
  pickupTimePromise,
  isLoading,
  defaultAddress,
  retailCategories,
  serviceCategories,
  setIsCategoryMenuOpen,
  isCategoryMenuOpen,
  dayPartMenu,
  dayPartMenuCategory,
  setSelectedMenu,
}: CmaHeaderProps) => {
  const { merchant } = useMerchant();
  const pathname = usePathname();
  const isSimpleStorefront = merchant?.merchantMeta?.selectedSetup === "Simple";
  const { handleDeviceBack } = useNativeBridge();
  const { isCmaApp } = useNativeActions();
  return (
    <nav
      className={clsx(
        "flex",
        "flex-col",
        "justify-center",
        "items-center",
        "w-full",
        "top-0",
        "z-10",
        "bg-[#FBFBFB]",
        "pt-3"
      )}
      data-testid={applyDataTestId(pom.header.headerContainer)}
    >
      <div className="flex items-center justify-center w-full px-4 pt-6 relative">
        <div className="absolute left-3">
          <button className="" onClick={handleDeviceBack}>
            <ArrowLeftIcon />
          </button>
        </div>
        <div className="w-full px-12 flex justify-center min-w-0">
          <HeaderMerchantInfoContainer
            merchantLogo={merchant.logo}
            merchantName={merchant.name}
            isSimpleStorefront={isSimpleStorefront}
            isStandaloneGiftCard={merchant?.isStandaloneGiftCardWebsite}
            merchantAddress={merchant?.address}
            merchantPhone={merchant?.phone}
            merchantLocale={merchant?.locale}
          />
        </div>
      </div>
      {isSimpleStorefront && pathname !== ROUTE_CONFIRMATION && (
        <SimpleStorefrontHours
          merchant={merchant}
          todayHours={todaysHours}
          abbreviation={merchant.timezone}
          headerBusinessHours={businessHours}
          merchantPaymentConfig={merchantPaymentConfig}
        />
      )}
      {pathname !== ROUTE_CONFIRMATION &&
        !merchant.isStandaloneGiftCardWebsite && (
          <div className={"w-full"}>
            <NavigationBar
              menu={menu}
              customerPerks={customerDetails?.earnedPerks}
              merchantPreferences={merchantPreferences}
              retailCategories={retailCategories}
              serviceCategories={serviceCategories}
              pickupTimePromise={pickupTimePromise}
              defaultAddress={defaultAddress}
              isLoading={isLoading}
              setIsCategoryMenuOpen={setIsCategoryMenuOpen}
              isCategoryMenuOpen={isCategoryMenuOpen}
              dayPartMenus={dayPartMenu}
              dayPartMenuCategories={dayPartMenuCategory}
              selectedMenu={selectedMenu}
              setSelectedMenu={setSelectedMenu}
              isNotAcceptingOrder={isNotAcceptingOrders}
            />
          </div>
        )}
      <NotAcceptingOrdersBanner
        merchant={merchant}
        isNotAcceptingOrder={isNotAcceptingOrders}
        selectedDayPart={selectedMenu}
      />
    </nav>
  );
};
